import type { ID } from '#shared/model/primitives'

let lastVirtualId = Number.MAX_SAFE_INTEGER / 2

export function generateVirtualId(): ID {
  return ++lastVirtualId
}
